export default "Les CEE Bâtiment financent l'isolation, le chauffage et l'éclairage des locaux professionnels. Découvrez les montants éligibles pour votre TPE/PME et déposez votre dossier.";
